import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import _ from "lodash";
import TextField from "../../../components/commons/TextField";
import Select from "../../../components/commons/SelectInput";
import { MenuItem, InputAdornment } from "@material-ui/core";
import {
  PageTitle,
  P,
  Heading,
  Separator,
  Button,
  Space,
  Box,
  Loader,
} from "../../../components/commons";
import { Check } from "../../../components/commons/icons";
import { SuccessModal } from "../../../components/commons/Modals";
import { getCurrentTime } from "../../../utils/helper";
import enums from "../../../utils/enums";
import moment from "moment";
import { selectSharesOptions } from "./selectors";
import * as actions from "./actions";
import { DashboardScreens } from "../DashboardInstance/Dashboard";

const frequencyOptions = enums.AutoPayFrequency;
const autopayMethodOptions = enums.QuickPayToAutoPayMethod;

class EditAutopay extends Component {
  static propTypes = {
    payFromOptions: PropTypes.array,
    goBack: PropTypes.func,
    autoPay: PropTypes.object,
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    changeEPaymentsError: PropTypes.func,
    showAutoPayUpdateConfirmModal: PropTypes.func,
    hideAutoPayUpdateConfirmModal: PropTypes.func,
    autoPayUpdateConfirmModalOpen: PropTypes.bool,
    push: PropTypes.func,
    updateAutoPay: PropTypes.func,
  };
  state = {
    frequency: "Select Frequency",
    method: enums.QuickPayToAutoPayMethod.CONTINUOUS,
    nextDate: getCurrentTime(),
    numberOfPayments: 0,
    paymentAmount: "",
    finalPaymentAmount: "",
    payFrom: "",
  };
  componentWillMount() {
    if (!this.props.autoPay || !this.props.autoPay.uniqueId) {
      // no auto pay was selected or came here by mistake... redirect to main payments page
      this.props.push("/dashboard/payments");
    }
  }
  componentDidMount() {
    const {
      frequency,
      remaining,
      nextDate,
      regularAmount,
      finalAmount,
      fromAccountId,
    } = this.props.autoPay;
    let numberOfPayments;
    let method;
    if (typeof remaining === "number") {
      numberOfPayments = remaining;
      method = enums.QuickPayToAutoPayMethod.FIXED;
    } else if (remaining.toLowerCase() === "continuous") {
      numberOfPayments = 0;
      method = enums.QuickPayToAutoPayMethod.CONTINUOUS;
    } else {
      numberOfPayments = parseInt(remaining, 10);
      method = enums.QuickPayToAutoPayMethod.FIXED;
    }
    this.setState({
      frequency,
      method,
      nextDate: moment(nextDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
      numberOfPayments,
      paymentAmount: regularAmount,
      finalPaymentAmount: finalAmount,
      payFrom: fromAccountId,
    });
  }
  handleEditAutoPay() {
    /*
  payload should be:
    - autoPayUniqueId
    - frequency       --> enum
    - nextDate        --> MM/DD/YYYY
    - method          --> enum
    - amount
    - fromAccountId
    - fromAccountType --> enum
    - paymentCount    --> not required
    - finalAmount     --> not required
	*/
    const {
      frequency,
      nextDate,
      method,
      paymentAmount,
      payFrom,
      numberOfPayments,
      finalPaymentAmount,
    } = this.state;
    if (!this.props.autoPay.uniqueId) {
      this.props.changeEPaymentsError("Auto pay is not valid.");
      return;
    }
    if (!frequency && frequency !== 0) {
      this.props.changeEPaymentsError("Frequency is required.");
      return;
    }
    if (!nextDate || !moment(nextDate).isValid()) {
      this.props.changeEPaymentsError("Next date is invalid.");
      return;
    }
    if (!method) {
      this.props.changeEPaymentsError("Method is required.");
      return;
    }
    if (!paymentAmount) {
      this.props.changeEPaymentsError("Payment amount is required.");
      return;
    }
    if (!payFrom && payFrom !== 0) {
      this.props.changeEPaymentsError("Pay from is required");
      return;
    }
    if (method === enums.QuickPayToAutoPayMethod.FIXED && !numberOfPayments) {
      this.props.changeEPaymentsError("Number of payments is required");
      return;
    }
    this.props.updateAutoPay(
      this.props.autoPay.uniqueId,
      frequency,
      moment(nextDate).format("MM/DD/YYYY"),
      method,
      parseInt(paymentAmount, 10),
      payFrom,
      enums.AccountType.SHARE,
      numberOfPayments || 0,
      parseInt(finalPaymentAmount, 10) || 0,
    );
  }
  renderSuccessModal() {
    return (
      <SuccessModal
        isOpen={this.props.autoPayUpdateConfirmModalOpen}
        onClose={() => this.props.hideAutoPayUpdateConfirmModal()}
        headingText="AutoPay updated successfully!"
        successIcon={<Check />}
        aria={{
          labelledby: "heading",
          describedby: "full_description",
        }}
      />
    );
  }
  render() {
    const renderContinuousFields = this.state.method ===
      enums.QuickPayToAutoPayMethod.FIXED && (
      <div>
        <TextField
          type="number"
          id="numberOfPayments"
          label="Number of Payments*"
          name="numberOfPayments"
          aria-label="Number Of Payments"
          value={this.state.numberOfPayments}
          onChange={e => this.setState({ numberOfPayments: e.target.value })}
        />

        <TextField
          type="text"
          id="finalPaymentAmount"
          label="Final Payment Amount*"
          name="finalPaymentAmount"
          aria-label="Final Payment Amount"
          value={this.state.finalPaymentAmount}
          onChange={e => this.setState({ finalPaymentAmount: e.target.value })}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
        />
      </div>
    );
    return (
      <DashboardScreens>
        <div>
          <Loader isLoading={this.props.isFetching} />
          {this.renderSuccessModal()}
          <PageTitle>Edit Auto Pay</PageTitle>
          <Separator style={{ margin: "1.5rem 0" }} />
          <P>
            To edit auto pay <strong>{this.props.autoPay.payeeName}</strong>, <br />{" "}
            please change/fill the information below and click OK.
          </P>
          <Separator style={{ margin: "1.5rem 0" }} />
          <Heading>
            Payement Information <small>(* Required fields)</small>
          </Heading>
          <form
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginBottom: "3rem",
              padding: 1,
            }}
          >
            <Select
              id="frequency"
              name="frequency"
              aria-label="Payees Names"
              label={"Frequency*"}
              onChange={e => this.setState({ frequency: e.target.value })}
              value={this.state.frequency}
            >
              <MenuItem value={this.state.frequency}>{this.state.frequency}</MenuItem>
              {frequencyOptions &&
                _.map(frequencyOptions, (option, key) => (
                  <MenuItem key={key} value={option}>
                    {key}
                  </MenuItem>
                ))}
            </Select>

            <TextField
              type="date"
              id="nextDate"
              label="Next Payment Date"
              name="nextDate"
              aria-label="Next Payment Date"
              value={this.state.nextDate}
              onChange={e => this.setState({ nextDate: e.target.value })}
            />

            <TextField
              type="text"
              id="paymentAmount"
              label="Payment Amount*"
              name="paymentAmount"
              aria-label="Payment Amount"
              value={this.state.paymentAmount}
              onChange={e => this.setState({ paymentAmount: e.target.value })}
              startAdornment={<InputAdornment position="start">$</InputAdornment>}
            />

            <Select
              id="method"
              name="method"
              aria-label="Auto Pay Method"
              label={"Auto Pay Method*"}
              onChange={e => this.setState({ method: e.target.value })}
              value={this.state.method}
            >
              {autopayMethodOptions &&
                _.map(autopayMethodOptions, (option, key) => (
                  <MenuItem key={key} value={option}>
                    {key}
                  </MenuItem>
                ))}
            </Select>

            {renderContinuousFields}

            <Select
              id="payFrom"
              name="payFrom"
              aria-label="Pay From"
              label={"Pay From*"}
              onChange={e => this.setState({ payFrom: e.target.value })}
              value={this.state.payFrom}
            >
              {this.props.payFromOptions &&
                _.map(this.props.payFromOptions, (option, key) => (
                  <MenuItem key={key} value={option.key}>
                    {option.value}
                  </MenuItem>
                ))}
            </Select>
          </form>
          {this.props.error ? (
            <P style={{ color: "darkred" }}> {this.props.error} </P>
          ) : (
            ""
          )}
          <Box>
            <Button danger onClick={() => this.props.goBack()}>
              Cancel
            </Button>
            <Space />
            <Button onClick={() => this.handleEditAutoPay()} primary>
              OK
            </Button>
          </Box>
        </div>
      </DashboardScreens>
    );
  }
}
const mapStateToProps = state => ({
  payFromOptions: selectSharesOptions(state),
  autoPay: state.epayment.autoPayForUpdate,
  error: state.epayment.error,
  isFetching: state.epayment.isFetching,
  autoPayUpdateConfirmModalOpen: state.epayment.autoPayUpdateConfirmModalOpen,
});
export default connect(mapStateToProps, { goBack, ...actions })(EditAutopay);
